// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Hq2","right":"styles_right__3wFXS"};